<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px">
            <ion-item>
                <ion-thumbnail slot="start" style="width: 75px; height: 75px; padding: 0 0 25px 0">
                    <img v-if="image" :src="image" alt="Produkt">
                    <ion-skeleton-text v-else animated></ion-skeleton-text>
                </ion-thumbnail>
                <ion-label mode="md" class="ion-text-wrap">
                    <ion-badge v-if="badge" style="margin-bottom: 5px">{{ badge }}</ion-badge>
                    <h3>{{ name }}</h3>
                    <div v-html="description"></div>
                </ion-label>
            </ion-item>
            <ion-card-content>
                <ion-row>
                    <ion-col size="33%">
                        <ion-button mode="ios" fill="outline" size="small">-</ion-button>
                        <span style="display: inline-block; margin-top: 8px; padding: 0 5px; vertical-align: middle; font-size: 13px">1</span>
                        <ion-button mode="ios" fill="outline" size="small">+</ion-button>
                    </ion-col>
                    <ion-col>
                        <h3 style="display: inline-block; margin-top: 8px;">{{ priceString }}</h3>
                    </ion-col>
                    <ion-col size="33%" class="text-right">
                        <ion-button mode="ios" fill="outline" size="small" @click="remove($event, index, slug)">Usuń</ion-button>
                    </ion-col>
                </ion-row>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    export default {
        name: 'ItemCart',
        props: ['index', 'id', 'slug', 'name', 'description', 'price', 'priceString', 'badge', 'image'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {
            remove(e, index, slug){
                e.preventDefault();
                this.$ionic.alertController
                    .create({
                        header: 'Usuwanie',
                        message: 'Czy na pewno chcesz usunąć ten produkt z koszyka?',
                        buttons: [
                            {
                                text: 'Anuluj',
                                role: 'cancel',
                                handler: () => {

                                },
                            },
                            {
                                text: 'Tak',
                                handler: () => {
                                    let payload = {
                                        'index' : index,
                                        'slug' : slug
                                    }
                                    this.$store.dispatch('shopGlass/SHOP_GLASS_CART_PRODUCT_DELETE', payload);
                                    this.$store.dispatch('GLOBAL_TOAST','Usunięto produkt z koszyka.');
                                }
                            }
                        ],
                        mode: 'md'
                    })
                    .then(a => a.present())
            },
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 6px;
    }
</style>